module.exports = __webpack_public_path__ + "img/ic-mujerazul.660e2b9f.png";